import { usePollVersion } from "@/infrastructure/rest";
import { importantToast } from "@/shared/components";
import { useRef } from "react";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export function useVersionCheck() {
    const bootVersion = useRef<string | null>(null);
    const lastNotifiedVersion = useVersionNotificationStore((s) => s.lastNotifiedVersion);
    const setLastNotifiedVersion = useVersionNotificationStore((s) => s.setLastNotifiedVersion);

    const { data: version } = usePollVersion();

    if (!version) return;

    if (!bootVersion.current) {
        bootVersion.current = version;
        return;
    }

    const hasNotified = lastNotifiedVersion === version;
    if (version !== bootVersion.current && !hasNotified) {
        importantToast(
            "Er is een nieuwe versie van SEIN beschikbaar",
            "Ververs de pagina om de laatste versie te gebruiken.",
            "Ververs",
            () => window.location.reload()
        );
        setLastNotifiedVersion(version);
    }
}

type VersionNotificationStore = {
    lastNotifiedVersion: string | null;
    setLastNotifiedVersion: (version: string) => void;
};

const useVersionNotificationStore = create<VersionNotificationStore>()(
    persist(
        (set) => ({
            lastNotifiedVersion: null,
            setLastNotifiedVersion: (version: string) =>
                set((state) => ({
                    ...state,
                    lastNotifiedVersion: version,
                })),
        }),
        {
            name: "version-notifications",
        }
    )
);
